import { useState } from "react";
import { useNavigate, useRouteLoaderData } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/Modal";
import { useAuthStore, User } from "src/components/main/authStore";
import {
    objAscSort, objDescSort, month, mon
} from "src/components/common/functions";
const items = [
    {key: "birthYear", title: "Year of Birth"}, 
    {key: "bd", title: "BirthDay"}, 
    {key: "age", title: "Age"}, 
    {key: "hireDate", title: "Hire Date"}, 
    {key: "years", title: "Years With Construct Smarter"}
];
export default function BirthDayForm(){
    const navigate = useNavigate();
    const {users: filteredUser} = useRouteLoaderData("userList") as {users: User[]}; // this is one page data, not all data.  
    const user = useAuthStore(state => state.user) as User;
    const [currentPage, setCurrentPage] = useState(0);
    const [columnOrder, setColumnOrder] = useState({title: "", direciton: 0});
    const data = filteredUser
    .filter(f => !f.quitDate && f.birthDay)
    .map(f => ({
        userName: f.userName,
        email: f.email,
        birthYear: f.birthDay.split("-")[0], 
        birthMonth: f.birthDay.split("-")[1], 
        bd:f.birthDay.split("-").slice(1).join("-"),
        age: window.Math.floor((new Date().getTime() - new Date(f.birthDay.replace(/-/g,"/")).getTime())/1000/60/60/24/365.25),
        hireDate: f.hireDate,
        years: window.parseFloat(((new Date().getTime() - new Date(f.hireDate.replace(/-/g,"/")).getTime())/1000/60/60/24/365.25).toFixed(2))
    }));
    if(columnOrder.direciton === 1){
        data.sort((a, b) => objAscSort(a, b, columnOrder.title));
    }else if(columnOrder.direciton === -1){
        data.sort((a, b) => objDescSort(a, b, columnOrder.title));
    }
    const tableData = data.filter(d => window.parseInt(d.birthMonth) === currentPage + 1);
    return (
        <Modal
            touchOutsideClose = {true}
            closeIt = {() => navigate("..")}
            title = "BirthDay"
            width = {1000} maxWidth = {"100%"}
        >
            <div className = "h3 my-4">{month[currentPage]}</div>
            <div className = "table-responsive">
                <table className = "table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            {user.personel === "edit"?<>
                            {items.map((item, itemIndex) => 
                            <th key = {itemIndex}
                                style = {{cursor: "pointer"}}
                                onMouseOver = {e => {e.currentTarget.style.color = "red"}}
                                onMouseLeave = {e => {e.currentTarget.style.color = "black"}}
                                onClick = {() => {
                                    if(columnOrder.title !== item.key){
                                        setColumnOrder({title: item.key, direciton: 1});
                                    }else{
                                        if(columnOrder.direciton === 1){
                                            setColumnOrder(obj => ({...obj, direciton: -1}));
                                        }else{
                                            setColumnOrder(obj => ({...obj, direciton: obj.direciton + 1}));
                                        }
                                    }
                                }}
                            >
                                {item.title} {columnOrder.title === item.key?<>{columnOrder.direciton === 0?<></>:(columnOrder.direciton === -1?<>↑</>:<>↓</>)}</>:<></>}
                            </th>)}
                            </>:null}
                        </tr>
                    </thead>
                    <tbody>
                        {!tableData.length?
                        <tr><td colSpan = {10} className = "text-center">Empty</td></tr>
                        :tableData.map((d, di) => 
                        <tr key = {di}>
                            <td className = "text-nowrap">{d.userName}</td>
                            {user.personel === "edit"?<>
                            <td className = "text-nowrap">{d.birthYear}</td>
                            <td className = "text-nowrap">{d.bd}</td>
                            <td className = "text-nowrap">{d.age}</td>
                            <td className = "text-nowrap">{d.hireDate}</td>
                            <td>
                                <div className = "d-flex align-items-center">
                                    <div className = "progress" style = {{width: `${Math.trunc(d.years /  Math.max(...tableData.map(x => x.years)) * 17)}vw`}}>
                                        <div className = "progress-bar progress-bar-striped w-100" role = "progressbar"></div>
                                    </div>
                                    <div className = "ms-3">{d.years}</div>
                                </div>
                            </td>
                            </>:null}
                        </tr>)}
                    </tbody>
                </table>
            </div>
            <nav className = "d-flex my-2 overflow-auto pagination">
                {mon.map((monthShortName, monthShortNameIndex) => (
                <span key = {monthShortNameIndex} className = "page-item">
                    <span
                        style = {{background: currentPage === monthShortNameIndex?"#e9ecef":undefined, cursor: "pointer"}}
                        className = "page-link"
                        onClick = {() => setCurrentPage(monthShortNameIndex)}
                    >
                    {monthShortName}
                    </span>
                </span>
                ))}
            </nav>
        </Modal>
    )
}